import React from 'react';
import { backgroundColorOptions, textColorOptions } from './theme/colors';

// Minimal footer aligned with the simplified design
const FooterComponent = ({
  companyName = 'eiei',
  logoUrl = '',
  copyrightText = `© ${new Date().getFullYear()} eiei`,
  impressumUrl = 'https://ei4heidelberg.de/impressum',
  datenschutzUrl = 'https://ei4heidelberg.de/datenschutz',
  backgroundColor = 'gray-50',
  textColor = 'gray-500',
  showDivider = true,
  align = 'spread'
}) => {
  // Removed color resolution - now using Tailwind dark mode classes

  const alignmentClasses = (() => {
    switch (align) {
      case 'center':
        return 'justify-center md:justify-center';
      case 'start':
        return 'justify-center md:justify-start';
      case 'spread':
      default:
        return 'justify-center md:justify-between';
    }
  })();

  return (
    <footer className="w-full bg-gray-50 dark:bg-slate-800 text-gray-500 dark:text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {showDivider && <div className="border-t border-current/10" />}
        <div className={`flex flex-col md:flex-row items-center py-6 text-sm gap-4 md:gap-6 ${alignmentClasses}`}>
          <div className="flex items-center gap-3">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={companyName}
                className="h-6 w-auto"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            ) : (
              <div className="text-base font-semibold">{companyName}</div>
            )}
          </div>

          <nav className="flex items-center gap-6">
            <a href={impressumUrl || '#'} className="transition-colors hover:text-current">
              Impressum
            </a>
            <a href={datenschutzUrl || '#'} className="transition-colors hover:text-current">
              Datenschutz
            </a>
          </nav>

          <div>
            <span>{copyrightText}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export const Footer = {
  fields: {
    companyName: {
      type: 'text',
      label: 'Firmenname'
    },
    logoUrl: {
      type: 'text',
      label: 'Logo URL'
    },
    copyrightText: {
      type: 'text',
      label: 'Copyright-Text'
    },
    impressumUrl: {
      type: 'text',
      label: 'Impressum URL'
    },
    datenschutzUrl: {
      type: 'text',
      label: 'Datenschutz URL'
    },
    backgroundColor: {
      type: 'select',
      label: 'Hintergrundfarbe',
      options: backgroundColorOptions()
    },
    textColor: {
      type: 'select',
      label: 'Textfarbe',
      options: textColorOptions()
    },
    showDivider: {
      type: 'radio',
      label: 'Trennlinie anzeigen',
      options: [
        { label: 'Ja', value: true },
        { label: 'Nein', value: false }
      ]
    },
    align: {
      type: 'select',
      label: 'Ausrichtung',
      options: [
        { label: 'Verteilt', value: 'spread' },
        { label: 'Links', value: 'start' },
        { label: 'Zentriert', value: 'center' }
      ]
    }
  },
  defaultProps: {
    companyName: 'eiei',
    logoUrl: '',
    copyrightText: `© ${new Date().getFullYear()} eiei`,
    impressumUrl: 'https://ei4heidelberg.de/impressum',
    datenschutzUrl: 'https://ei4heidelberg.de/datenschutz',
    backgroundColor: 'gray-50',
    textColor: 'gray-500',
    showDivider: true,
    align: 'spread'
  },
  render: FooterComponent
};
